import React from "react";

import {Grid} from "@material-ui/core";
import TextField from '@mui/material/TextField';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import esLocale from "date-fns/locale/es";
import {Appointment} from '../../../../plas/services/residues/models';
import Button from "@mui/material/Button";
import CancelIcon from "@mui/icons-material/Cancel";
import LoadingButton from "@mui/lab/LoadingButton";
import DoneIcon from "@mui/icons-material/Done";
import SearchIcon from "@mui/icons-material/TravelExplore";
import Chip from "@mui/material/Chip";
import * as Constants from "../../../../consts/Constants.js";
import {MapContainer, Marker, TileLayer} from "react-leaflet";
import L from "leaflet";
import BlueMarker from "../../../../assets/images/markers/blueMarker.png";
import * as Nominatim from "nominatim-browser";
import {Coordinate} from "../../../../plas/utils/geographics/models";
import alerter from "../../../alerts/alerter";
import InputMask from "react-input-mask";
import service from "../../../../plas/services/residues/service";

export default function AppointmentForm({
    initialAppointment,
    zones,
    residueTypes,
    onCancel,
    onSave,
    fullWidth
}) {

    const theme = createTheme({
        palette: {
            primary: {
                main: '#FFFFFF', darker: '#FFFFFF',
            }
        },
    });

    const [appointment, setAppointment] = React.useState(initialAppointment);
    const [otherResidueTypes, setOtherResidueTypes] = React.useState(residueTypes.filter((residueType) => appointment.details.find((detail) => detail.id === residueType.id) == null))
    const [selectedResidueType, setSelectedResidueType] = React.useState(null);

    const [map, setMap] = React.useState(null);
    const [center, setCenter] = React.useState(appointment.location.coordinate == null ? { lat: Constants.LATITUD_AYACUCHO, lng: Constants.LONGITUD_AYACUCHO } : { lat: appointment.location.coordinate.latitude, lng: appointment.location.coordinate.longitude })
    const markerRef = React.useRef(null)

    const [searching, setSearching] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {

    }, []);

    const saveHandler = () => {
        if (appointment.id === 0) {
            create();
        } else {
            update()
        }
    }

    const create = () => {
        setSaving(true)
        service.api.appointments.create(appointment, (response) => {
          if (response.result != null) {
            if (onSave)
              onSave(response.result);
          } else {
            alerter.showError(response.error);
          }
          setSaving(false)
        });
    }

    const update = () => {
       /* setSaving(true)
        service.api.appointments.update(eventId, event, (response) => {
            if (response.result != null) {
                if (onSave)
                    onSave(response.result);
            } else {
                alerter.showError(response.error);
            }
            setSaving(false)
        });*/
    }


    const searchAddress = () => {
        setSearching(true);

        let input = appointment.location.address + ", Ayacucho, Buenos Aires, Argentina";

        return Nominatim.geocode({
            q: input,
            addressdetails: true,
        }).then((results) => {
            setSearching(false);
            if (results.length !== 0) {
                let result = results[0];

                if (map != null)
                    map.setView([result.lat, result.lon], 17);

                appointment.location.coordinate = new Coordinate({ latitude: result.lat, longitude: result.lon });
                let zone = getZone(appointment.location.coordinate);
                appointment.location.setZone(zone);
                setAppointment(new Appointment(appointment));
                setCenter({ "lat": result.lat, "lng": result.lon } )
                alerter.showSuccess("Dirección encontrada. Puedes arrastrar el marcador para corregir la ubicación del lugar.")
            } else {
                alerter.showInfo("No se pudo encontrar la dirección, pero puedes arrastrar el marcador manualmente para indicar la ubicación del lugar.")
            }
        }).catch(() => {
            setSearching(false);
            alerter.showInfo("Ocurrió un error al buscar la dirección, pero puedes arrastrar el marcador manualmente para indicar la ubicación del lugar.")
        });
    };

    const getZone = (coordinate) => {
        let currentZone = zones[0]
        if (coordinate != null) {
            zones.forEach((zone) => {
                if (zone.contains(coordinate)) {
                    currentZone = zone
                }
            });
        }
        return currentZone
    }

    const changeName = (event) => {
        appointment.contactInformation.name = event.target.value;
        setAppointment(new Appointment(appointment));
    }

    const changePhoneNumber = (event) => {
        appointment.contactInformation.phoneNumber = event.target.value.replaceAll(/\s/g, '').replaceAll('_', '');
        setAppointment(new Appointment(appointment));
    }

    const changeDate = (newDate) => {
        if (newDate != null) {
            appointment.setDate(newDate);
            setAppointment(new Appointment(appointment));
        }
    }

    const changeAddress = (event) => {
        appointment.location.address = event.target.value;
        setAppointment(new Appointment(appointment));
    }

    const removeDetail = (residueType) => {
        let newOthersResidueTypes = otherResidueTypes;
        let labeled = residueTypes.find((item) => item.id === residueType.id);
        newOthersResidueTypes.push(labeled)
        setOtherResidueTypes(newOthersResidueTypes);
        appointment.removeDetail(residueType);
        setAppointment(new Appointment(appointment))
    }

    const addDetail = () => {
        let newOthersResidueTypes = otherResidueTypes.filter((residueType) => residueType.id !== selectedResidueType.id)
        setOtherResidueTypes(newOthersResidueTypes);
        appointment.addDetail(selectedResidueType);
        setSelectedResidueType(null)
    }

    const onChangeResidueType = (residueType) => {
        setSelectedResidueType(residueType)
    }

    const markerEventHandlers = {
        dragend() {
            const marker = markerRef.current
            if (marker != null) {
                appointment.location.coordinate = new Coordinate({latitude: marker.getLatLng().lat, longitude: marker.getLatLng().lng});
                let zone = getZone(appointment.location.coordinate);
                appointment.location.setZone(zone);
                setAppointment(new Appointment(appointment))
            }
        }
    }

    const markerIcon = new L.Icon({
        iconUrl: BlueMarker,
        popupAnchor: [0, -30],
        iconSize: new L.Point(26, 39),
        iconAnchor: [13, 39]
    });

    const ColoredLine = ({color}) => (<hr
        style={{
            color: color, backgroundColor: color, marginTop: 6, marginBottom: 16, height: 2
        }}
    />);

    return (
        <Grid container>
            <Grid item xs={12} style={{textAlign: "center"}}>
                <Grid container spacing={2}>
                    <Grid item xs={false} md={fullWidth ? false : 2}/>
                    <Grid item xs={12} md={fullWidth ? 12 : 8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <p style={{fontSize: '28px', textAlign: 'left'}}>
                                    Datos del turno
                                </p>
                                <ColoredLine color="gray"/>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={8}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} style={{textAlign: "left"}}>
                                            <span style={{fontSize: 16}}>
                                                Datos de contacto
                                            </span>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            required
                                                            variant="outlined"
                                                            id="name"
                                                            label="Nombre"
                                                            name="name"
                                                            onChange={(event) => { changeName(event) }}
                                                            disabled={saving}
                                                            value={appointment.contactInformation.name}
                                                            fullWidth
                                                            placeholder="Nombre"/>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <InputMask
                                                            mask="+54 9999999999"
                                                            onChange={(event) => { changePhoneNumber(event) }}
                                                            value={appointment.contactInformation.phoneNumber}
                                                            disabled={saving}
                                                            maskChar="_">
                                                            {
                                                                () =>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        id="phoneNumber"
                                                                        label="Teléfono"
                                                                        name="phoneNumber"
                                                                        fullWidth
                                                                        placeholder="+54 249 123456 "/>
                                                            }
                                                        </InputMask>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} style={{textAlign: "left"}}>
                                            <span style={{fontSize: 16}}>
                                                Fecha y lugar
                                            </span>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={"auto"} style={{textAlign: "left"}}>
                                                        <LocalizationProvider
                                                            adapterLocale={esLocale}
                                                            dateAdapter={AdapterDateFns}>
                                                            <DatePicker
                                                                disabled={saving}
                                                                label="Fecha"
                                                                value={appointment.getDate()}
                                                                onChange={(newValue) => { changeDate(newValue) }}
                                                                renderInput={(params) => <TextField required fullWidth variant="outlined" {...params}/>}>
                                                            </DatePicker>
                                                        </LocalizationProvider>
                                                    </Grid>
                                                    <Grid item xs={true}>
                                                        <TextField
                                                            variant="outlined"
                                                            id="name"
                                                            label="Dirección"
                                                            name="name"
                                                            value={appointment.location.address}
                                                            onChange={ (event) => { changeAddress(event) }}
                                                            fullWidth
                                                            placeholder="Av. Siempreviva 742"/>
                                                    </Grid>
                                                    <Grid item xs={"auto"}>
                                                        <ThemeProvider theme={theme}>
                                                            <Box
                                                                display="flex"
                                                                justifyContent="center"
                                                                alignItems="center"
                                                                height="100%">
                                                                <LoadingButton
                                                                    style={{width: 130}}
                                                                    loadingPosition="start"
                                                                    startIcon={<SearchIcon/>}
                                                                    loading={ searching }
                                                                    variant="contained"
                                                                    fullWidth
                                                                    onClick={ searchAddress }>
                                                                    <b>Buscar</b>
                                                                </LoadingButton>
                                                            </Box>
                                                        </ThemeProvider>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} style={{textAlign: "left"}}>
                                                { appointment.location.zone != null ? (
                                                    <span style={{fontSize: 16}}>
                                                        Zona {appointment.location.zone.name} -
                                                        { !appointment.location.zone.isEnabled(appointment.getDate()) ?
                                                            <span style={{color: "darkred"}}> La zona no está planificada para el día seleccionado</span>:
                                                            <span style={{color: "darkgreen"}}> La zona está planificada en el día seleccionado</span>
                                                        }
                                                    </span>
                                                ) : (
                                                    <span style={{fontSize: 14}}>
                                                        Ninguna zona establecida
                                                    </span>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} style={{textAlign: "left"}}>
                                                <span style={{fontSize: 16}}>
                                                    Residuos
                                                </span>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={true}>
                                                        <Autocomplete
                                                            options={otherResidueTypes}
                                                            disabled={saving}
                                                            renderInput={(params) =>
                                                                <TextField
                                                                    variant="outlined"
                                                                    id="role"
                                                                    label="Tipos de residuos"
                                                                    name="role"
                                                                    fullWidth
                                                                    placeholder="Ingresa un residuo"
                                                                    { ...params }/>
                                                            }
                                                            value={selectedResidueType}
                                                            onChange={(event, newValue) => onChangeResidueType(newValue)}/>
                                                    </Grid>
                                                    <Grid item xs={"auto"}>
                                                        <Box
                                                            display="flex"
                                                            justifyContent="center"
                                                            alignItems="center"
                                                            height="100%">
                                                            <Button
                                                                style={{width: 130}}
                                                                disabled={!selectedResidueType || saving}
                                                                loadingPosition="start"
                                                                startIcon={<DoneIcon/>}
                                                                variant="contained"
                                                                onClick={addDetail}>
                                                                <b>Asignar</b>
                                                            </Button>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} style={{textAlign: 'left'}}>
                                                        {appointment.details.map((item, index) => (
                                                            <Chip key={index} disabled={saving}
                                                                  style={{margin: '4px', fontSize: '15px'}}
                                                                  label={item.name} variant="outlined"
                                                                  onDelete={() => removeDetail(item)}/>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            height="100%">
                                            <MapContainer
                                                style={{
                                                    height: "100%",
                                                    minHeight: 300,
                                                    width: "100%"
                                                }}
                                                center={center}
                                                zoom={15}
                                                whenCreated={setMap}
                                                scrollWheelZoom={true}>

                                                <Marker
                                                    draggable={ appointment.id === undefined || appointment.id === 0 }
                                                    eventHandlers={markerEventHandlers}
                                                    key={ "marker" }
                                                    icon={ markerIcon }
                                                    ref={markerRef}
                                                    position={ center }>
                                                </Marker>

                                                <TileLayer
                                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                            </MapContainer>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            { onCancel || onSave ? (
                                <Grid item xs={12}>
                                    <ColoredLine color="gray"/>
                                    <Grid container spacing={2}>
                                        <Grid item xs={true}/>
                                        <Grid item>
                                            { onCancel ? (
                                                <ThemeProvider theme={theme}>
                                                    <Button
                                                        disabled={saving}
                                                        startIcon={<CancelIcon/>}
                                                        variant="contained"
                                                        onClick={() => onCancel()}>
                                                        Cancelar
                                                    </Button>
                                                </ThemeProvider>) : null
                                            }
                                        </Grid>
                                        <Grid item>
                                            {onSave ? (
                                                <LoadingButton
                                                    disabled={!appointment.isValid()}
                                                    loadingPosition="start"
                                                    startIcon={<DoneIcon/>}
                                                    loading={saving && appointment.isValid()}
                                                    variant="contained"
                                                    onClick={saveHandler}>
                                                    <b>{appointment.id ? "Guardar" : "Crear"}</b>
                                                </LoadingButton>) : null
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>) : null
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={false} md={fullWidth ? false : 2}/>
                </Grid>
            </Grid>
        </Grid>
    )
}

/*
{ this.props.data != null && this.props.data.zones.map((zone) => (
    <Polygon
        key={zone.id}
        positions={zone.coordinates}
        fillColor={zone.color}
        fillOpacity={0.65}
        color="#000000"
        weight={2}
        opacity={1}
        eventHandlers={{
            click: () => {
                this.selectZone(zone.id)
            },
        }}>
        <Tooltip>{zone.name}</Tooltip>
    </Polygon>
))}

{ this.props.data != null && this.props.data.zones.map((zone) => (
    <div key={-zone.id}>
        { this.props.hihglightZone === zone.id ? (
            <Polygon
                positions={zone.coordinates}
                fillColor={zone.color}
                fillOpacity={0}
                color="#000000"
                weight={4}
                opacity={1}
                eventHandlers={{
                    click: () => {
                        this.selectZone(zone.id)
                    },
                }}>
                <Tooltip>{zone.name}</Tooltip>
            </Polygon>
        ) : (null)
        }
    </div>
))}

 */